/**
 * 取り寄せ・予約商品の同梱ブロック (Winds Score / 2026-08-18)
 *
 * 対象の商品は**単独でのみ**購入できる。カートに入れられるのは**1明細だけ**。
 * 対象同士(取り寄せ+取り寄せ、予約+予約、取り寄せ+予約)も同梱できない。
 * 同一バリエーションの数量増しは許す(明細は1つのままなので)。
 *
 * ■ 対象の判定(2つ)
 *   ① バリエーション名に「**【取り寄せ】**」を含む …… /【取り寄せ】/
 *      ⚠ **「【取寄】」は対象外**(2026-08-18 スタッフ判断)。取り寄せでも他の商品と
 *        一緒に買えるようにしたい商品(リード類など)を「【取寄】」と短く書いて
 *        区別する運用になっている。**表記の使い分けがそのまま同梱可否の指定**。
 *        → 同梱不可にしたい商品は「【取り寄せ】」、同梱を許す商品は「【取寄】」と書く
 *   ② **商品タグ**に「予約受付中」がある …… バリエーション名の「【予約】」では見ない。
 *      予約期間が終わってタグを外せば制限も外れる運用にしたいため(2026-08-18 Shingo)
 *
 * ■ なぜ自作するか
 *   従来はアプリ「Order Limits」で実現していたが、対象が自動コレクション
 *   「バリエーションの名前に『取り寄せ』を含む」で、**Shopify のコレクションは商品単位に
 *   丸められる**ため誤ブロックしていた。実例: 「吹奏楽合奏叩き棒」は20バリエーション中
 *   1つだけが取り寄せなのに、在庫のある19色まで購入できなくなっていた(2026-08-17 実測)。
 *   → バリエーション単位で判定するためテーマ側に持つ。
 *
 * ■ ¥0のノベルティは「同梱の相手」に数えない(2026-08-18)
 *   アプリ **CartBot** が、特定のクラリネット商品を入れると
 *   「【プレゼント用】クラリネット専用ドアサイン」(¥0)を**サーバー側で自動追加**する。
 *   これを1明細として数えると、取り寄せのクラリネット商品を1点入れただけで
 *   「明細2つ」になり**買えなくなる**(2026-08-18 に実害を確認)。
 *   そのため **price が 0 の明細は判定から除く**。
 *   ※ これがあるため、以前は Order Limits を避ける目的で
 *     バリエーション名を「【取寄】」と短く書いて対象外にする運用が取られていた。
 *     この対応でその回避は不要になり、表記を統一しなくても正しく動く。
 *
 * ■ 商品タグの取り方
 *   /cart.js の明細に tags は入らないが handle は入るので、handle ごとに
 *   /products/<handle>.js を1回だけ引いてキャッシュする。
 *
 * ■ 止め方
 *   ボタンを disabled にするのが主の防御。click の preventDefault では
 *   テーマ/アプリ側が capture フェーズで form.submit() を直接呼ぶため間に合わない
 *   (2026-07-30 実測。wsqty-confirm.js と同じ考え方)。
 *
 * ■ 限界(Shingo 了承済み・2026-08-18)
 *   ブラウザ側の制御なので /cart/add.js を直接叩けば回避できる。
 *   (置き換え前の Order Limits はサーバー側で 422 を返していた)
 */
(function () {
  'use strict';

  if (window.__wsPreorderLoaded) return;
  window.__wsPreorderLoaded = true;

  var PREORDER_NAME = /【取り寄せ】/;   // ⚠「【取寄】」は意図的に対象外(上のコメント参照)
  var RESERVE_TAG = '予約受付中';
  var MSG = '取り寄せ商品・予約商品は、単独でのご注文をお願いしております。'
          + 'ほかの商品とは同時にご購入いただけません。ご注文を分けてください。';

  var cart = null;
  var product = null;   // 商品ページで見ている商品
  var variantNames = null;
  var tagCache = {};    // handle → 予約受付中を持つか

  function isPreorderName(n) { return PREORDER_NAME.test(String(n || '')); }
  function hasReserveTag(tags) {
    if (!tags) return false;
    var list = Array.isArray(tags) ? tags : String(tags).split(',');
    return list.some(function (t) { return String(t).trim() === RESERVE_TAG; });
  }

  /** 明細の表示名(variant_title が無い単一バリエーション商品も拾う) */
  function lineName(i) {
    var name = i.variant_title || '';
    if (!name && i.options_with_values) {
      name = i.options_with_values.map(function (o) { return o.value; }).join(' / ');
    }
    return name;
  }
  function cartItems() { return (cart && cart.items) || []; }
  /** 支払いが発生する明細だけ。¥0のノベルティは「同梱」の相手として数えない */
  function payingItems() { return cartItems().filter(function (i) { return (i.price || 0) > 0; }); }
  function isRestrictedLine(i) {
    return isPreorderName(lineName(i)) || tagCache[i.handle] === true;
  }
  function restrictedLines() { return payingItems().filter(isRestrictedLine); }

  // ------------------------------------------------------------------ 取得
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { cart = j; return j; })
      .catch(function () { return null; });
  }

  function fetchProductJs(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /** カート内の商品タグを埋める(未取得の handle だけ) */
  function loadCartTags() {
    var seen = {};
    var need = [];
    cartItems().forEach(function (i) {
      var h = i.handle;
      if (h && tagCache[h] === undefined && !seen[h]) { seen[h] = 1; need.push(h); }
    });
    return Promise.all(need.map(function (h) {
      return fetchProductJs(h)
        .then(function (p) { tagCache[h] = hasReserveTag(p.tags); })
        .catch(function () { tagCache[h] = false; });
    }));
  }

  /** 商品ページで見ている商品(バリエーション名とタグ) */
  function loadProduct() {
    if (product !== null || variantNames !== null) return Promise.resolve();
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) { product = false; variantNames = {}; return Promise.resolve(); }
    return fetchProductJs(m[1])
      .then(function (p) {
        product = p;
        variantNames = {};
        (p.variants || []).forEach(function (v) { variantNames[String(v.id)] = v.title || v.name || ''; });
        if (p.handle) tagCache[p.handle] = hasReserveTag(p.tags);
      })
      .catch(function () { product = false; variantNames = {}; });
  }

  /** 現在選択中のバリエーション名 */
  function selectedVariantName(form) {
    var id = form && form.querySelector('[name="id"]');
    var v = id && id.value;
    if (v && variantNames && variantNames[String(v)] !== undefined) return variantNames[String(v)];
    var sels = form ? form.querySelectorAll('select[data-index], input[type="radio"]:checked') : [];
    return [].map.call(sels, function (e) { return e.value; }).join(' / ');
  }

  // ------------------------------------------------------------------ 表示
  function noticeFor(el) {
    var box = el.parentNode.querySelector('[data-wspre-msg]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-wspre-msg', '');
      box.className = 'wspre__msg';
      box.hidden = true;
      el.parentNode.insertBefore(box, el.nextSibling);
    }
    return box;
  }

  /** ボタンの disabled は wsqty-confirm.js とも取り合いになる。
   *  後に走ったほうが勝つので、**自分がロックした印**を付けて、
   *  相手が false に戻したら attribute 監視で復元する。
   *  自分がロックしていないときは相手の判断に手を出さない(2026-08-18 本番で競合を実測)。 */
  function apply(el, block) {
    var box = noticeFor(el);
    var want = !!block;
    if (want) {
      el.setAttribute('data-wspre-locked', '');
      if (el.disabled !== true) el.disabled = true;              // 同値なら触らない(監視の再帰防止)
      el.setAttribute('aria-disabled', 'true');
    } else if (el.hasAttribute('data-wspre-locked')) {
      el.removeAttribute('data-wspre-locked');
      if (el.disabled !== false) el.disabled = false;            // 自分が掛けたロックだけ外す
      el.setAttribute('aria-disabled', 'false');
    }
    if (box.hidden !== !want) box.hidden = !want;
    var text = want ? MSG : '';
    if (box.textContent !== text) box.textContent = text;
  }

  function syncProductForm(form) {
    var btn = form.querySelector('[name="add"], .add-to-cart, button[type="submit"]');
    if (!btn) return;
    var idInput = form.querySelector('[name="id"]');
    var selId = idInput ? String(idInput.value) : '';
    // 選択中のバリエーションが取り寄せ、または**この商品**が予約受付中なら対象
    var mine = isPreorderName(selectedVariantName(form))
            || (product && hasReserveTag(product.tags));
    // 同じバリエーションの数量増しは許すので、自分以外の明細だけを見る
    var others = payingItems().filter(function (i) { return String(i.variant_id) !== selId; });
    apply(btn, mine ? others.length > 0 : restrictedLines().length > 0);
  }

  function syncCartForm(form) {
    var btn = form.querySelector('[name="checkout"]');
    if (!btn) return;
    if (!form.querySelectorAll('input[name="updates[]"]').length) return; // 商品行が無いフォームは判定しない
    apply(btn, restrictedLines().length > 0 && payingItems().length > 1);
  }

  function syncAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncProductForm);
    document.querySelectorAll('#CartPageForm, #CartDrawerForm').forEach(syncCartForm);
  }

  function refresh() {
    return fetchCart()
      .then(loadProduct)
      .then(loadCartTags)
      .then(syncAll);
  }

  /** 連続呼び出しをまとめる */
  var refreshTimer = null;
  function refreshSoon(ms) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, ms || 250);
  }

  function init() {
    refresh();
    // バリエーション変更時もカートを取り直す。カートが古いと
    // 「他に何が入っているか」を誤って判定する(2026-08-18 本番で踏んだ)
    document.addEventListener('change', function () { syncAll(); refreshSoon(250); }, true);
    if (window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(syncAll, 120);
      }).observe(document.body, {
        childList: true, subtree: true,
        // disabled の変化も見る。wsqty-confirm.js が false に戻したら掛け直すため
        attributes: true, attributeFilter: ['disabled']
      });
    }
    // カートが変わりうる操作のあとだけ取り直す
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('form[action*="/cart"], #CartPageForm, #CartDrawerForm, a[href*="/cart/change"]')) {
        // テーマの Ajax がいつ終わるか読めないので何度か取り直す。
        // 1回(900ms)だけだと追加が終わる前に取ってしまい、古いカートで判定していた
        [400, 1200, 2600].forEach(function (ms) { setTimeout(refresh, ms); });
      }
    }, true);
    // テーマが Ajax でカートを作り直したときのイベント。
    // このテーマは数量欄の change では動かず 'cart:build' で再描画する
    // (2026-08-02 カートを空にするボタンの実装時に確認済み)
    ['cart:build', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(refresh, 250); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', refresh);
})();
